import { defineStore, storeToRefs } from 'pinia'
import { useAuthStore } from './auth'
import { computed } from 'vue'

const permissions = {
  canEditSentBudgets: 'edit_sent_budgets',
  canValidateManualCreatedPolicies: 'can_validate_manual_created_policies',
  canContinueWithInactivePolicy: 'can_continue_with_inactive_policy'
} as const

export type PermissionsType = keyof typeof permissions

export const usePermissions = defineStore('permissions', () => {
  const auth = useAuthStore()
  const { user } = storeToRefs(auth)

  const currentUserPermissions = computed(() => {
    return user.value?.permit ?? {}
  })

  const userPermissions = computed(() => {
    const tempPermissions: Record<PermissionsType, boolean> = {} as Record<PermissionsType, boolean>
    Object.entries(permissions).forEach(([key, permission]) => {
      tempPermissions[key as PermissionsType] = searchPermission(
        currentUserPermissions.value,
        permission
      )
    })
    return tempPermissions
  })

  return {
    userPermissions
  }
})

function searchPermission(permissions: Record<string, boolean>, permission: string): boolean {
  const normalizedPermission = permission.toLowerCase()
  return Object.entries(permissions).some(
    ([key, value]) => key.toLowerCase() === normalizedPermission && value === true
  )
}
